import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static values = {
        currentStatus: String,
        confirmTitle: String,
        confirmText: String,
        confirmButton: String,
        cancelButton: String
    }

    confirmChange(event) {
        const newStatus = event.target.value

        // If clicking the current status (shouldn't happen with radios if checked, but good for safety)
        if (newStatus === this.currentStatusValue) return

        // Simple confirm for now. We can enhance UI later if needed.
        // The user requirement is "prompt que pida confirmacion y avise"
        const confirmMessage = `${this.confirmTitleValue}\n\n${this.confirmTextValue.replace('%{status}', event.target.nextElementSibling.innerText.trim())}`

        if (!window.confirm(confirmMessage)) {
            event.preventDefault()
            // Revert selection
            const originalRadio = this.element.querySelector(`input[type="radio"][value="${this.currentStatusValue}"]`)
            if (originalRadio) {
                originalRadio.checked = true
            }
        } else {
            // Update current status value to the new accepted status
            // so subsequent changes revert to this one if cancelled
            this.currentStatusValue = newStatus
        }
    }
}
